import { RadialProgressBarCSSStyleImpl } from '../../../../toolkit/radialprogressbar/radialprogressbarcss';

export class BannerProgressBarCSSStyleImpl extends RadialProgressBarCSSStyleImpl
{
    getInnerWrapper():object
    {
        return{
          fontSize:'84.5px'
        };
    }
    getPieDivCSSStyle():object
    {
        return{
            position: 'absolute',
            top: '-1px',
            right: '-0.001px',
            width: '100%',
            height: '100%',
        };
    }

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannercard/bannerprogressbarcss.tsx